import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private readonly TOKEN_KEY = 'sessionToken';

  private tokenCliente = '';

  constructor() {}



  // 🔹 Guardar token
  saveToken(token: string): void {
    sessionStorage.setItem(this.TOKEN_KEY, token);
  }

  saveTokenCliente(tokenCliente: string): void {
    if (tokenCliente) {
      this.tokenCliente = tokenCliente;
    } else {
      this.tokenCliente = '';
    }
  }

  // 🔹 Obtener token
  getToken(): string | null {
    return sessionStorage.getItem(this.TOKEN_KEY);
  }

  getTokenCliente(): string | null {
    return this.tokenCliente;
  }

  // 🔹 Eliminar token
  removeToken(): void {
    sessionStorage.removeItem(this.TOKEN_KEY);
  }
}
